import React, { memo } from "react";
import { XAxis } from "@chartLib/lib/axes";
import PropTypes from "prop-types";

const XAxisBase = memo(
  ({ themeColors, showGrid = false, gridHeight = 0, showAxis = true }) => {
    // If neither grid nor axis requested, render nothing
    if (!showGrid && !showAxis) return null;

    // Grid axis (vertical grid lines) should render whenever showGrid is true,
    // even if showAxis is false. The grid axis uses large negative innerTickSize
    // to draw vertical grid lines across the chart height and hides labels/domain.
    if (showGrid) {
      // When grid is enabled, render single axis with grid lines and labels
      return (
        <XAxis
          axisAt="bottom"
          orient="bottom"
          stroke={themeColors.basicColor}
          edgeClip={false}
          innerTickSize={-1 * gridHeight}
          tickStroke={themeColors.gridColor}
          tickStrokeOpacity={1}
          tickStrokeDasharray="2, 6"
          showTickLabel={showAxis}
          tickLabelFill={themeColors.basicColor}
          xZoomHeight={20}
          showDomain={showAxis}
          zoomEnabled={false}
        />
      );
    }

    // Normal axis with ticks and labels when grid is disabled
    return showAxis ? (
      <XAxis
        axisAt="bottom"
        orient="bottom"
        stroke={themeColors.basicColor}
        edgeClip={false}
        innerTickSize={5}
        tickStroke={themeColors.basicColor}
        tickLabelFill={themeColors.basicColor}
        xZoomHeight={20}
        showDomain={true}
        zoomEnabled={false}
      />
    ) : null;
  },
);

XAxisBase.displayName = "XAxisBase";

XAxisBase.propTypes = {
  themeColors: PropTypes.object.isRequired,
  showGrid: PropTypes.bool,
  gridHeight: PropTypes.number,
  showAxis: PropTypes.bool,
};

// Defaults moved into parameter defaults to be compatible with React.memo

export default XAxisBase;
